var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    height: "48px",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.55,35.47h10.27l0.02-0.11c1.37-7.07,1.37-14.34,0-21.42l-0.02-0.11H11.55c-5.91,0-10.71,4.79-10.71,10.71 v0.22C0.84,30.67,5.63,35.47,11.55,35.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.95,28.54c0.68,0,1.12-0.56,1.2-1.12c0.08-0.54-0.17-1.18-0.89-1.38l-9.83-2.82 c0.03-0.09,0.05-0.19,0.09-0.28c0.1-0.25,0.23-0.48,0.37-0.73c0.06-0.11,0.13-0.23,0.19-0.34l8.5,2.44 c0.12,0.04,0.25,0.05,0.37,0.05c0.68,0,1.12-0.56,1.2-1.12c0.08-0.54-0.17-1.18-0.89-1.38l-8.5-2.44c0.02-0.26,0.04-0.53,0.04-0.82 v-3.85c0-1.21-1.91-1.21-1.91,0v3.97c0,0.05-0.01,0.1-0.01,0.16l-7.77-2.23c-0.12-0.04-0.25-0.05-0.37-0.05 c-0.68,0-1.12,0.56-1.2,1.11c-0.08,0.54,0.17,1.18,0.89,1.38l7.76,2.23c-0.04,0.09-0.08,0.17-0.12,0.26 c-0.18,0.37-0.32,0.74-0.44,1.11l-6.52-1.87c-0.12-0.04-0.25-0.05-0.37-0.05c-0.68,0-1.12,0.56-1.2,1.12 c-0.08,0.54,0.17,1.18,0.89,1.38l6.98,2.01c0.01,0.06,0.01,0.12,0.02,0.18c0.1,0.53,0.27,1.02,0.46,1.5l-6.78-1.95 c-0.12-0.04-0.25-0.05-0.37-0.05c-0.68,0-1.12,0.56-1.2,1.12c-0.08,0.54,0.17,1.18,0.89,1.38l8.43,2.42 c0.02,0.16,0.04,0.32,0.04,0.49v3.81c0,0.61,0.49,0.93,0.96,0.93c0.46,0,0.95-0.33,0.95-0.93v-3.75l7.79,2.24 c0.12,0.04,0.25,0.05,0.37,0.05c0.68,0,1.12-0.56,1.2-1.11c0.08-0.54-0.17-1.18-0.89-1.38l-9.12-2.62 c-0.04-0.11-0.09-0.21-0.13-0.31c-0.2-0.48-0.4-0.93-0.54-1.42l9.11,2.62C45.71,28.52,45.83,28.54,45.95,28.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.80bcf8374b214c7c7f9415b43eb5b442.svg";
export { ForwardRef as ReactComponent };